/**
 * State used in rendering BreadcrumbItem
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
